export default [{
    path: '/contact',
    name: 'Contact',
    component: () => import('../../views/My/Filed/Contact.vue'),
    meta: {
        title: '联系我们',
        keepAlive: false,
    }
},
{
    path: '/message',
    name: 'Message',
    component: () => import('../../views/My/Filed/Message.vue'),
    meta: {
        title: '留言',
        keepAlive: false,
    }  
}
]


// WEBPACK FOOTER //
// ./src/router/modules/filed.js